"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _bi = require("react-icons/bi");

var _constants = require("./constants");

var _ai = require("react-icons/ai");

var _bs = require("react-icons/bs");

var _overflowMenu = _interopRequireDefault(require("../overflow-menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.tree-node-parent-node-container:hover {\n  background-color: #e0e0e0; }\n\n.tree-node-parent-node-container {\n  height: 3rem; }\n\n.tree-node-container {\n  height: fit-content;\n  min-width: 19rem;\n  width: max-content;\n  position: relative; }\n\n.tree-node-container:first-child {\n  margin-left: 0; }\n\n.tree-node-tracking-line-container {\n  position: absolute;\n  top: 3rem;\n  z-index: 100;\n  height: calc(100% - 48px);\n  border-left: 0.0625rem solid #c6c6c6; }\n\n.tree-node-dir-icon {\n  display: flex;\n  margin-right: 0.5rem;\n  min-width: 1.5rem;\n  min-height: 1.5rem;\n  max-width: 1.5rem;\n  max-height: 1.5rem; }\n\n.tree-node-parent-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 0;\n  padding: 0.75rem 1rem;\n  height: 3rem;\n  box-sizing: border-box; }\n  .tree-node-parent-container .tree-node-parent-container-left-wrapper {\n    display: flex;\n    align-items: center; }\n  .tree-node-parent-container .tree-node-action-item-holder {\n    width: 1.5rem;\n    height: 1.5rem; }\n\n.tree-node-parent-icon {\n  margin-right: 0.5rem; }\n\n.tree-node-parent-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0; }\n\n.tree-node-content-box-container:hover {\n  background-color: #e0e0e0; }\n\n.tree-node-content-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 0;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  height: 3rem;\n  box-sizing: border-box;\n  padding-left: 3.25rem; }\n  .tree-node-content-box .tree-node-content-box-left-wrapper {\n    display: flex; }\n  .tree-node-content-box .tree-node-action-item-holder {\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-right: 0.5rem; }\n\n.tree-node-content-box-icon {\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.tree-node-content-box-text {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.tree-node-content-box-select,\n.tree-node-parent-node-container-select {\n  background-color: #d0e2ff; }\n  .tree-node-content-box-select:hover,\n  .tree-node-content-box-select :active,\n  .tree-node-parent-node-container-select:hover,\n  .tree-node-parent-node-container-select :active {\n    background-color: #d0e2ff; }\n\n.tree-node-content-box-icon,\n.tree-node-dir-icon,\n.tree-node-parent-icon {\n  color: #6f6f6f; }\n\n.tree-node-content-box-text,\n.tree-node-content-box-text,\n.tree-node-parent-text {\n  color: #393939;\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  letter-spacing: 0.02rem; }\n";
  var fileName = "compone_treeNode";
  var element = document.querySelector("style[data-sass-component='compone_treeNode']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var renderDirectionIcon = function renderDirectionIcon(expanded) {
  return expanded ? /*#__PURE__*/_react.default.createElement(_bi.BiChevronDown, {
    size: _constants.defaultIconSize
  }) : /*#__PURE__*/_react.default.createElement(_bi.BiChevronRight, {
    size: _constants.defaultIconSize
  });
};

var LeafNode = function LeafNode(_ref) {
  var _leafClass;

  var leave = _ref.leave,
      level = _ref.level,
      clickHandler = _ref.clickHandler,
      parents = _ref.parents,
      actionClickHandler = _ref.actionClickHandler,
      selectedItemParents = _ref.selectedItemParents,
      actionItems = _ref.actionItems;
  var contentBoxRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHover = _useState4[0],
      setHover = _useState4[1];

  (0, _react.useLayoutEffect)(function () {
    contentBoxRef.current.style.marginLeft = "".concat(_constants.trackingLineInitialWidth + _constants.trackingLineRestWidth * level, "px");
  }, []);
  (0, _react.useEffect)(function () {
    setSelected(false);
    var nextArrayLength = selectedItemParents === null || selectedItemParents === void 0 ? void 0 : selectedItemParents.length;
    var nextCounter = 0;
    if ((parents === null || parents === void 0 ? void 0 : parents.length) <= (selectedItemParents === null || selectedItemParents === void 0 ? void 0 : selectedItemParents.length)) for (var i = 0; i < nextArrayLength; i++) {
      var _parents$i, _selectedItemParents$;

      if (parents[i] && selectedItemParents[i] && ((_parents$i = parents[i]) === null || _parents$i === void 0 ? void 0 : _parents$i.label) === ((_selectedItemParents$ = selectedItemParents[i]) === null || _selectedItemParents$ === void 0 ? void 0 : _selectedItemParents$.label)) nextCounter++;else break;
    }
    if (nextCounter === nextArrayLength) setSelected(true);
  });
  var leafClass = (_leafClass = {}, _defineProperty(_leafClass, _constants.TreeNodeClasses.contentBoxContainer, true), _defineProperty(_leafClass, _constants.TreeNodeClasses.contentBoxSelect, selected), _leafClass);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, leafClass)),
    onClick: function onClick() {
      clickHandler(parents);
    },
    tabIndex: _constants.tabIndex,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.contentBox,
    ref: contentBoxRef,
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.contentBoxLeftWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.contentBoxIcon
  }, /*#__PURE__*/_react.default.createElement(_bs.BsLock, {
    size: _constants.defaultIconSize
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.contentBoxText
  }, /*#__PURE__*/_react.default.createElement("span", null, leave.label))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.actionIconHolder
  }, isHover && Boolean(actionItems.length) && /*#__PURE__*/_react.default.createElement(_overflowMenu.default, {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    options: leave.actionItems,
    getOptionLabel: function getOptionLabel(option) {
      return option.title;
    },
    onChange: function onChange(event, value) {
      event.stopPropagation();
      setHover(false);
      actionClickHandler(parents, value);
    }
  }))));
};

var ParentNode = function ParentNode(_ref2) {
  var _parentNodeClass;

  var name = _ref2.name,
      actionItems = _ref2.actionItems,
      expansionHandler = _ref2.expansionHandler,
      expandedItems = _ref2.expandedItems,
      expanded = _ref2.expanded,
      level = _ref2.level,
      parents = _ref2.parents,
      clickHandler = _ref2.clickHandler,
      isNodesEmpty = _ref2.isNodesEmpty,
      isLeavesEmpty = _ref2.isLeavesEmpty,
      actionClickHandler = _ref2.actionClickHandler,
      expandIconClickHandler = _ref2.expandIconClickHandler,
      hasChildren = _ref2.hasChildren,
      selectedItemParents = _ref2.selectedItemParents;
  var parentRef = (0, _react.useRef)();
  var parentContainerRef = (0, _react.useRef)();

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isHover = _useState8[0],
      setHover = _useState8[1];

  (0, _react.useLayoutEffect)(function () {
    parentRef.current.style.marginLeft = "".concat(level === 0 ? 0 : _constants.trackingLineInitialWidth + _constants.trackingLineRestWidth * (level - 1) + _constants.trackingLineSeperation, "px");
  }, []);
  (0, _react.useEffect)(function () {
    for (var i = 0; i < (expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.length); i++) {
      var _expandedItems$i;

      if (((_expandedItems$i = expandedItems[i]) === null || _expandedItems$i === void 0 ? void 0 : _expandedItems$i.length) === (parents === null || parents === void 0 ? void 0 : parents.length)) {
        var counter = 0;

        for (var j = 0; j < parents.length; j++) {
          var _expandedItems$i$j, _parents$j;

          if (((_expandedItems$i$j = expandedItems[i][j]) === null || _expandedItems$i$j === void 0 ? void 0 : _expandedItems$i$j.label) !== ((_parents$j = parents[j]) === null || _parents$j === void 0 ? void 0 : _parents$j.label)) break;else counter++;
        }

        if (counter === (parents === null || parents === void 0 ? void 0 : parents.length)) {
          expansionHandler();
          break;
        }
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    setSelected(false);
    var parentsArrayLength = selectedItemParents === null || selectedItemParents === void 0 ? void 0 : selectedItemParents.length;
    var nextCounter = 0;
    if ((parents === null || parents === void 0 ? void 0 : parents.length) <= (selectedItemParents === null || selectedItemParents === void 0 ? void 0 : selectedItemParents.length)) for (var i = 0; i < parentsArrayLength; i++) {
      var _parents$i2, _selectedItemParents$2;

      if (parents[i] && selectedItemParents[i] && ((_parents$i2 = parents[i]) === null || _parents$i2 === void 0 ? void 0 : _parents$i2.label) === ((_selectedItemParents$2 = selectedItemParents[i]) === null || _selectedItemParents$2 === void 0 ? void 0 : _selectedItemParents$2.label)) nextCounter++;else break;
    }
    if (nextCounter === parentsArrayLength) setSelected(true);
  });
  var parentNodeClass = (_parentNodeClass = {}, _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainer, true), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainerSelect, selected), _parentNodeClass);
  var expandIconTabIndex = !(isNodesEmpty() && isLeavesEmpty()) ? _constants.tabIndex : _constants.tabIndexNegative;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, parentNodeClass)),
    ref: parentContainerRef,
    onClick: function onClick() {
      clickHandler(parents);
    },
    tabIndex: _constants.tabIndex,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.parentContainer,
    ref: parentRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.treeNodeParentContainerLeftWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.dirIconContainer,
    onClick: function onClick(e) {
      e.stopPropagation();
      expansionHandler();
      expandIconClickHandler && expandIconClickHandler(parents);
    },
    tabIndex: expandIconTabIndex
  }, hasChildren && renderDirectionIcon(expanded)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.parentIcon
  }, /*#__PURE__*/_react.default.createElement(_ai.AiOutlineFolder, {
    size: _constants.defaultIconSize
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.parentText
  }, name)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.actionIconHolder
  }, isHover && Boolean(actionItems.length) && /*#__PURE__*/_react.default.createElement(_overflowMenu.default, {
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    options: actionItems,
    getOptionLabel: function getOptionLabel(option) {
      return option.title;
    },
    onChange: function onChange(event, value) {
      event.stopPropagation();
      setHover(false);
      actionClickHandler(parents, value);
    }
  }))));
};

var TreeNode = function TreeNode(_ref3) {
  var nodes = _ref3.nodes,
      level = _ref3.level,
      parents = _ref3.parents,
      clickHandler = _ref3.clickHandler,
      expandIconClickHandler = _ref3.expandIconClickHandler,
      actionClickHandler = _ref3.actionClickHandler,
      selectedItemParents = _ref3.selectedItemParents,
      expandedItems = _ref3.expandedItems;

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      expanded = _useState10[0],
      setExpanded = _useState10[1];

  var borderNode = (0, _react.useRef)();
  var containerNode = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    if (expanded && (!isLeavesEmpty() || !isNodesEmpty())) {
      borderNode.current.style.left = "".concat(_constants.trackingLineInitialWidth + _constants.trackingLineRestWidth * level, "px");
    }
  });

  var expansionHandler = function expansionHandler() {
    setExpanded(!expanded);
  };

  var isNodesEmpty = function isNodesEmpty() {
    return !nodes.nodes || nodes.nodes.length === 0;
  };

  var isLeavesEmpty = function isLeavesEmpty() {
    return !nodes.leaves || nodes.leaves.length === 0;
  };

  var parentNodeProps = {
    name: nodes.label,
    actionItems: nodes.actionItems,
    hasChildren: nodes.hasChildren,
    expansionHandler: expansionHandler,
    expandedItems: expandedItems,
    expanded: expanded,
    level: level,
    isNodesEmpty: isNodesEmpty,
    isLeavesEmpty: isLeavesEmpty,
    parents: [].concat(_toConsumableArray(parents), [_objectSpread({}, nodes)]),
    clickHandler: clickHandler,
    actionClickHandler: actionClickHandler,
    expandIconClickHandler: expandIconClickHandler,
    selectedItemParents: selectedItemParents
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.container,
    ref: containerNode
  }, /*#__PURE__*/_react.default.createElement(ParentNode, parentNodeProps), expanded && nodes.nodes && nodes.nodes.map(function (node, index) {
    var treeNodeProps = {
      nodes: node,
      level: level + 1,
      parents: [].concat(_toConsumableArray(parents), [_objectSpread({}, nodes)]),
      clickHandler: clickHandler,
      key: "".concat(_constants.treeNodeKey, "-").concat(nodes.label, "-").concat(index),
      actionClickHandler: actionClickHandler,
      expandIconClickHandler: expandIconClickHandler,
      selectedItemParents: selectedItemParents,
      expandedItems: expandedItems
    };
    return /*#__PURE__*/_react.default.createElement(TreeNode, treeNodeProps);
  }), expanded && nodes.leaves && nodes.leaves.map(function (leave, index) {
    var leafNodeProps = {
      clickHandler: clickHandler,
      actionItems: leave.actionItems,
      leave: leave,
      level: level,
      parents: [].concat(_toConsumableArray(parents), [_objectSpread({}, nodes), _objectSpread({}, leave)]),
      key: "".concat(_constants.leafNodeKey, "-").concat(nodes.label, "-").concat(index),
      actionClickHandler: actionClickHandler,
      selectedItemParents: selectedItemParents
    };
    return /*#__PURE__*/_react.default.createElement(LeafNode, leafNodeProps);
  }), expanded && (!isLeavesEmpty() || !isNodesEmpty()) && /*#__PURE__*/_react.default.createElement("div", {
    ref: borderNode,
    className: _constants.TreeNodeClasses.trackingLine
  }));
};

var _default = TreeNode;
exports.default = _default;